/* eslint-disable */

export interface Point {
  top: number;
  left: number;
}

export interface Area {
  width: number;
  height: number;
}

export type RectLayout = Point & Area;

export function addPoints(pprime: Point, ...ps: Point[]): Point {
  return {
    top: ps.reduce((acc, p) => acc + p.top, pprime.top),
    left: ps.reduce((acc, p) => acc + p.left, pprime.left),
  };
}

/// https://www.mathsisfun.com/definitions/subtrahend.html
export function subtractPoints(minuend: Point, ...subtrahends: Point[]): Point {
  return {
    top: subtrahends.reduce((acc, p) => acc - p.top, minuend.top),
    left: subtrahends.reduce((acc, p) => acc - p.left, minuend.left),
  };
}
